import { OfficeOnlineApp } from 'owa-file';

const WORD_EXTS = ['.docx', '.doc', '.docm', '.odt'] as const;
const EXCEL_EXTS = ['.xlsx', '.xlsm', '.xlsb', '.ods'] as const;
const POWERPOINT_EXTS = ['.pptx', '.ppxs', '.odp'] as const;

export function getPreloadURLForWXP(preloadMapping: {
    [ext: string]: string;
}): Record<OfficeOnlineApp, string | null> {
    // Get the preload edit for the various office apps
    const getFirstUrlForExts = (exts: ReadonlyArray<string>) => {
        const [url] = exts.map(ext => preloadMapping[ext]).filter(url => !!url);
        return url;
    };

    // Get and return the url for preloading that app
    return {
        [OfficeOnlineApp.Word]: getFirstUrlForExts(WORD_EXTS),
        [OfficeOnlineApp.Excel]: getFirstUrlForExts(EXCEL_EXTS),
        [OfficeOnlineApp.PowerPoint]: getFirstUrlForExts(POWERPOINT_EXTS),
    };
}
